import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

export default {
  async getTwilioToken({ commit, dispatch }, { identity, room }) {
    const r = await startLoading(dispatch, 'getTwilioToken', () =>
      http.get(`app/GetTwilioToken?identity=${identity}&id=${room}`)
    )
    commit(types.SET_TWILIO_TOKEN, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/app/actions.js